(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-semana-electro"]) return;
  try {
    
  const initVeloraElectro = () => {
    document.querySelectorAll('[data-velora-electro]').forEach((banner) => {
      if (banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';

      const messages = Array.from(banner.querySelectorAll('[data-electro-message]'));
      const timerDisplay = banner.querySelector('[data-electro-timer]');
      const speed = Number(banner.dataset.rotationSpeed) || 4000;
      const endAt = new Date(banner.dataset.endAt).getTime();
      let current = 0;
      let rotationTimer;
      let countdownTimer;

      const showMessage = (index) => {
        messages.forEach((message, messageIndex) => {
          const isActive = messageIndex === index;
          message.classList.toggle('is-active', isActive);
          message.setAttribute('aria-hidden', String(!isActive));
        });
      };

      const stopRotation = () => {
        window.clearInterval(rotationTimer);
        rotationTimer = undefined;
      };

      const startRotation = () => {
        if (messages.length < 2 || rotationTimer) return;
        rotationTimer = window.setInterval(() => {
          current = (current + 1) % messages.length;
          showMessage(current);
        }, speed);
      };

      const updateCountdown = () => {
        const remaining = endAt - Date.now();
        if (remaining <= 0) {
          window.clearInterval(countdownTimer);
          stopRotation();
          banner.closest('.velora-electro-section')?.remove();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (value) => String(value).padStart(2, '0');

        if (timerDisplay) {
          timerDisplay.textContent = `${pad(days)}D · ${pad(hours)}H · ${pad(minutes)}M · ${pad(seconds)}S`;
        }
      };

      showMessage(current);
      updateCountdown();
      countdownTimer = window.setInterval(updateCountdown, 1000);
      startRotation();
    });
  };

  initVeloraElectro();
  document.addEventListener('shopify:section:load', initVeloraElectro);

  } catch(e) { console.error(e); }
})();
})();
